/* eslint arrow-body-style: ["error", "always"] */
import { modalPropertyHelpReducer, modalPropertyHelpActions } from './ModalPropertyHelp';

import { modalPropertyReducer, modalPropertyActions } from './ModalProperty';

import { modalThemeAndConfigHelpReducer, modalThemeAndConfigHelpActions } from './ModalThemeAndConfigHelp';

import { modalThemeAndConfigReducer, modalThemeAndConfigActions } from './ModalThemeAndConfig';

import { modalGenericPropertyValuesReducer, modalGenericPropertyValuesActions } from './ModalGenericPropertyValues';

import { modalSaveReducer, modalSaveActions } from './ModalSave';

import { modalContentInfoReducer, modalContentInfoActions } from './ModalManageContentInfo';

import { modalConfirmationSettingsReducer, modalConfirmationSettingsActions } from './ModalConfirmationSettings';

// eslint-disable-next-line import/named
import { modalLabelSettingsReducer, modalLabelSettingsActions } from './ModalLabelSettings';

export {
    modalPropertyHelpReducer,
    modalPropertyHelpActions,
    modalPropertyReducer,
    modalPropertyActions,
    modalThemeAndConfigHelpReducer,
    modalThemeAndConfigHelpActions,
    modalThemeAndConfigReducer,
    modalThemeAndConfigActions,
    modalGenericPropertyValuesActions,
    modalGenericPropertyValuesReducer,
    modalSaveReducer,
    modalSaveActions,
    modalContentInfoReducer,
    modalContentInfoActions,
    modalConfirmationSettingsReducer,
    modalConfirmationSettingsActions,
    modalLabelSettingsActions,
    modalLabelSettingsReducer
};



// WEBPACK FOOTER //
// ./src/components/modals/AllModal.js